import { AssociatedInvoice } from "@portal/types/entities/invoice";

export const mapInvoicesColumnPredicate = (invoice: AssociatedInvoice) => {
  return {
    id: invoice.id,
    title: invoice.number,
    amount: invoice.balance_due_amount,
    currency: invoice.currency,
  };
};
